/* ─────────────────────────────────────────────────────────────────────────────
 *  snippets.ts — Featured snippet triggers for search results
 * ───────────────────────────────────────────────────────────────────────────── */

export interface FeaturedSnippet {
  triggers: string[];
  title: string;
  content: string;
  type: "text" | "list";
  listItems?: string[];
}

const SNIPPETS: FeaturedSnippet[] = [
  {
    triggers: ["resume", "cv", "download resume"],
    title: "Resume - Jasur Shukurov",
    content:
      "Lead Software Development Engineer at Amazon with experience in full-stack web development, mobile apps, and cloud services.",
    type: "text",
  },
  {
    triggers: ["skills", "tech stack", "technologies", "languages"],
    title: "Technical Skills",
    content: "Jasur Shukurov's technical expertise includes:",
    type: "list",
    listItems: [
      "Languages: TypeScript, JavaScript, Rust, Python, Java, Kotlin",
      "Frontend: React, Angular, Android (Kotlin/Java)",
      "Backend: Node.js, Spring Boot, AWS Lambda",
      "Cloud: AWS (Lambda, S3, DynamoDB, EC2), Firebase",
      "Tools: Git, Docker, CI/CD, Webpack",
    ],
  },
  {
    triggers: ["contact", "email", "reach", "hire"],
    title: "Contact Information",
    content:
      "The fastest way to reach Jasur is via email at jasur@shukurov.me. You can also connect on LinkedIn or check out projects on GitHub.",
    type: "text",
  },
  {
    triggers: ["education", "school", "university", "degree"],
    title: "Education",
    content: "Jasur Shukurov studied at:",
    type: "list",
    listItems: [
      "Adelphi University, Garden City NY — B.S. Computer Science",
      "Research Assistant & Software Engineer (2019 - 2021)",
    ],
  },
  {
    triggers: ["experience", "work", "career", "job"],
    title: "Professional Experience",
    content: "Career timeline:",
    type: "list",
    listItems: [
      "Lead SDE at Amazon.com LLC (2021 - Present)",
      "Research Assistant at Adelphi University (2019 - 2021)",
      "Intern at Blue Cross Blue Shield of MA (Summer 2019)",
      "Full-Stack Engineer at Anor Developers LLC (2016 - 2018)",
    ],
  },
];

export function findSnippet(query: string): FeaturedSnippet | undefined {
  const q = query.toLowerCase().trim();
  return SNIPPETS.find((s) => s.triggers.some((t) => q.includes(t)));
}
